import { useTheme } from '@approvalmax/theme';
import { AmaxPayFullLogo } from '@approvalmax/ui';
import { Box, Grid, SimpleLayout } from '@approvalmax/ui/src/components';
import { FC } from 'react';
import { useMeasure, useMedia } from 'react-use';

import { BackButton } from './resources/components';
import type { LayoutProps } from './resources/types';

export const Layout: FC<LayoutProps> = (props) => {
    const { content, stepper, help } = props;

    const { theme } = useTheme();
    const isSmallScreen = useMedia(`(max-width: ${theme.container.breakpoint.medium})`);
    const [ref, { width }] = useMeasure<HTMLDivElement>();

    return (
        <SimpleLayout size='small' verticalAlign='start' logo={<AmaxPayFullLogo />}>
            {isSmallScreen ? (
                <SimpleLayout.Top>
                    <Grid gap={20}>
                        <div>
                            <BackButton />
                        </div>

                        {stepper}
                    </Grid>
                </SimpleLayout.Top>
            ) : (
                <SimpleLayout.LeftSide>
                    <Grid alignContent='start' gap={20} padding='0 24 0 0' ref={ref}>
                        <div>
                            <BackButton />
                        </div>

                        <Box color='white100' radius='small' spacing='24'>
                            {stepper}
                        </Box>
                    </Grid>
                </SimpleLayout.LeftSide>
            )}

            <SimpleLayout.Content>{content}</SimpleLayout.Content>

            {/* right part need only to center the `SimpleLayout.Content` */}
            {isSmallScreen ? (
                <SimpleLayout.Footer>{help}</SimpleLayout.Footer>
            ) : (
                <SimpleLayout.RightSide>
                    <Grid alignContent='start' padding='48 0 0 24'>
                        <Box width={width}>{help}</Box>
                    </Grid>
                </SimpleLayout.RightSide>
            )}
        </SimpleLayout>
    );
};
